import { render, staticRenderFns } from "./ChineseMedicineDetails.vue?vue&type=template&id=53d99d97&"
import script from "./ChineseMedicineDetails.vue?vue&type=script&lang=js&"
export * from "./ChineseMedicineDetails.vue?vue&type=script&lang=js&"
import style0 from "./ChineseMedicineDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports